import { computed } from 'nanostores';

import { atom } from '@podium/store';
import {
  AdConfigIntermingle,
  AdConfigPlacement
} from '@schibsted-nmp/advertising-shared';

import { AtomChannels, AtomTopics } from './index';

export const $placementsAtom = atom<AdConfigPlacement[]>(
  AtomChannels.Podlet,
  AtomTopics.Placements,
  []
);

export const $interminglePlacements = computed(
  $placementsAtom,
  (placements: AdConfigPlacement[]) =>
    placements.filter((placement) => {
      const intermingle = placement.intermingle as AdConfigIntermingle;
      if (!intermingle) return false;

      // Recirc ads are not loaded as intermingle placements anymore. Instead, they are set up by the recommendation API
      // and rendered from the components in advertising-companion (AdvertisingWebComponent).
      const isRecircAd =
        placement.placementId.includes('recirc') ||
        placement.placementId.includes('ad-stream');
      if (isRecircAd) return false;
      return Boolean(intermingle.list && intermingle.grid);
    })
);
